import { render } from "./DealerWorkingHours.vue?vue&type=template&id=024bf72c"
import script from "./DealerWorkingHours.vue?vue&type=script&lang=js"
export * from "./DealerWorkingHours.vue?vue&type=script&lang=js"

import "./DealerWorkingHours.vue?vue&type=style&index=0&id=024bf72c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ChatWidget/DealerWorkingHours/DealerWorkingHours.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "024bf72c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('024bf72c', __exports__)) {
    api.reload('024bf72c', __exports__)
  }
  
  module.hot.accept("./DealerWorkingHours.vue?vue&type=template&id=024bf72c", () => {
    api.rerender('024bf72c', render)
  })

}


export default __exports__